module.exports = __webpack_public_path__ + "img/residencias.7e2ce7f1.jpg";